import { useContext } from "react";
import { Button } from "./button";
import { LanguageContext } from "./language-settings";
import { ContextMenu } from "./context-menu";
import "./language-selector.css";

const languageSettings = {
    da: { code: "da", text: "da", icon: "ic_flag_denmark", },
    de: { code: "de", text: "de", icon: "ic_flag_germany", },
    en: { code: "en", text: "en", icon: "ic_flag_united-kingdom"},
    fi: { code: "fi", text: "fi", icon: "ic_flag_finland", },
    fr: { code: "fr", text: "fr", icon: "ic_flag_france"},
    // lv: { code: "lv", text: "lv", icon: "ic_flag_latvia", },
    no: { code: "no", text: "no", icon: "ic_flag_norway", },
    se: { code: "se", text: "se", icon: "ic_flag_sweden" },
};

export function LanguageSelector() {
    const {language, setLanguage} = useContext(LanguageContext);
    return (
        <div className="language-selector">
            <ContextMenu
                align="left"
                icon={languageSettings[language].icon}
                buttonVariant="label"
                buttonContent={languageSettings[language].text}
            >
                {Object.values(languageSettings).map(setting => <Button
                    key={setting.code}
                    clicked={() => setLanguage(setting.code)}
                    icon={setting.icon}
                    variant="label"
                >
                    {setting.text}
                </Button>)}
            </ContextMenu>
        </div>
    )
}
